import {
  Flex,
  Progress,
  Text,
} from "@chakra-ui/react";

export const CustomProgressBar = ({ current, total, ...rest }) => {
  const percentage = (current / total) * 100;

  const getColorScheme = () => {
    if (percentage < 30) return "red";
    if (percentage >= 30 && percentage <= 80) return "yellow";
    return "green";
  };

  return (
    <Flex direction='column' w='100%' gap="10px" {...rest}>
      <Text fontSize='sm' fontWeight='bold'>
        {`${current} / ${total}`}
      </Text>

      <Progress colorScheme={getColorScheme()} size='xs' value={percentage} />
    </Flex>
  );
};
